/** `list[i]` for indices the caller knows are in range (loops, modulo walks). Throws otherwise. */
export function nth<T>(list: readonly T[], i: number): T {
  const v = list[i];
  if (v === undefined) throw new RangeError(`index ${i} out of range (${list.length})`);
  return v;
}

/** The value stored under key; throws when it is missing, which is a bug in the caller. */
export function got<K, V>(map: ReadonlyMap<K, V>, key: K): V {
  const v = map.get(key);
  if (v === undefined) throw new RangeError(`missing key ${String(key)}`);
  return v;
}
